import React, {useState} from 'react';
import {Modal, ModalActions, ModalBody} from '../../../components/Modal';
import {Button} from '../../../components/Button';
import Typography from '../../../components/Typography';
import EmployeeAvatar from '../../../components/EmployeeAvatar';
import {Chip} from '../../../components/Chip';
import {ApprovalInstance, ENTITY_TYPE_METADATA} from '../../../api/ApprovalApi';
import {Employee} from '../../../api/EmployeeApi';
import {StateBadge} from '../pending-requests/pending-requests/BaseRequestDetailModal';
import ApprovalActions from './ApprovalActions';
import {DetailRow, DetailSection} from "./BaseApprovalDetailComponents";
import {DateUtils} from "../../../util/DateUtils";
import {useTranslation} from "react-i18next";


function ColumnLabel({label}: { label: string }) {
    return (
        <Typography
            variant="overline"
            className="block mb-3 text-xs font-semibold tracking-wider uppercase"
            color="secondary"
        >
            {label}
        </Typography>
    );
}

export interface BaseApprovalDetailModalProps {
    instance: ApprovalInstance;
    open: boolean;
    onClose: () => void;
    onSuccess: (updated: ApprovalInstance) => void;
    title: string;
    employee?: Employee | null;
    instanceDetails?: React.ReactNode;
    children?: React.ReactNode;
}


export function BaseApprovalDetailModal({
                                            instance,
                                            open,
                                            onClose,
                                            onSuccess,
                                            title,
                                            employee,
                                            instanceDetails,
                                            children
                                        }: BaseApprovalDetailModalProps) {

    const {t} = useTranslation();

    const [submissionDate] = useState<Date>(new Date(instance.submittedAt));
    const [submittedBy] = useState<Employee>(instance.requestedBy.employee);

    const formattedDate = DateUtils.formatDate(submissionDate, {
        dateStyle: 'full',
        timeStyle: 'short'
    });

    const handleSuccess = (updated: ApprovalInstance) => {
        onSuccess(updated);
        onClose();
    };

    return (
        <Modal isOpen={open} onClose={onClose} size="xxl" title={title}>
            <ModalBody>

                {/* Employee header — spans full width */}
                {employee && (
                    <div className="flex items-center gap-3 mb-5 pb-4 border-b border-gray-100">
                        <EmployeeAvatar employee={employee}/>
                        <div>
                            <Typography variant="subtitle1" className="font-medium">
                                {employee.preferredName}
                            </Typography>
                        </div>
                        <div className="ml-auto flex items-center gap-2">
                            <Chip
                                label={ENTITY_TYPE_METADATA[instance.entityType]?.label ?? instance.entityType}
                                size="small"
                                color="warning"
                            />
                            <StateBadge state={instance.status}/>
                        </div>
                    </div>
                )}

                <div className="grid grid-cols-2 gap-3 mb-5 pb-4 border-b border-gray-100">
                    {instanceDetails && (
                        <div>
                            {instanceDetails}
                        </div>
                    )}

                    <DetailSection title={t('timeRecordRequest.detail.record', {defaultValue: 'Antragdetails'})}>
                        <DetailRow label={t('request.submittedAt')}>
                            {formattedDate}
                        </DetailRow>

                        <DetailRow label={t('request.submittedAt')}>
                            {submittedBy.preferredName}
                        </DetailRow>
                    </DetailSection>
                </div>

                {/*<div className="flex items-center gap-3 mb-5 pb-4 border-b border-gray-100">*/}
                {/*    <DetailSection title={t('timeRecordRequest.detail.record', {defaultValue: 'Antragdetails'})}>*/}
                {/*        <DetailRow label={t('request.submittedAt')}>*/}
                {/*            {formattedDate}*/}
                {/*        </DetailRow>*/}

                {/*        <DetailRow label={t('request.submittedAt')}>*/}
                {/*            {submittedBy.preferredName}*/}
                {/*        </DetailRow>*/}
                {/*    </DetailSection>*/}
                {/*</div>*/}

                {children}

            </ModalBody>

            <ModalActions>
                <Button variant="outlined" onPress={onClose}>
                    Schließen
                </Button>
                <ApprovalActions showCompact={false} instance={instance} onSuccess={handleSuccess}/>
            </ModalActions>
        </Modal>
    );
}